<template>
  <div>
    <HeadingDisplayLoader
      v-if="isLoading"
      :has-sub-title="false"
      size="small"
    />
    <HeadingDisplay
      v-else
      head="Extratos e notas"
      :title="portfolioName"
      size="small"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { HeadingDisplay } from '@warrenbrasil/nebraska-web';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';

interface Props {
  isLoading: boolean;
  portfolioName?: string;
}
const props = defineProps<Props>();

const portfolioName = computed(() => props.portfolioName || '-');
</script>

<style lang="less" scoped></style>
